import { createInjectionKey } from "../../_utils/index.mjs";
export const inputInjectionKey = createInjectionKey('n-input');